
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/account/security",
      function () {
        return require("private-next-pages/docs/account/security.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/account/security"])
      });
    }
  